import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class CommonserviceService {
  private namcId = new BehaviorSubject<string | null>(null);
  private roles = new BehaviorSubject<string | null>(null);

  constructor(private readonly http: HttpClient,
    private dataService: DataService)
    { }
    // Common Method for GET request with bearer token for Pie API
    public getPieData(endpoint: string): Observable<any> {
      const authToken = this.dataService.getPieToken();
      const pieApiUrl = environment.pieAPIUrl;
      const headers = new HttpHeaders({
        'Authorization': `Bearer ${authToken}`
      }); 
      return this.http.get(`${pieApiUrl}${endpoint}`, { headers });
    }

    public getHcmData(query: string, variables: any = {}): Observable<any> {
      const hcmDsUrl = environment.hcmDsUrl;
      const headers = new HttpHeaders().set('Content-Type', 'application/json');
      const body = {
        query,
        variables
      };
  
      return this.http.post(hcmDsUrl, body, { headers: headers });
    }

    public  getPieToken(): Observable<any> {
      const pieTokenUrl = environment.pieTokenUrl;
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
  
      return this.http.get<any>(pieTokenUrl);
    }

    public setNamc(nacm: string): void {
      this.namcId.next(nacm);
    }

    public getNamc(): BehaviorSubject<string> {
      return this.namcId;
    }

    public setRoles(roles: string): void {
      this.roles.next(roles);
    }

    public getRoles(): BehaviorSubject<string> {
      return this.roles
    }

}
